import Alpine from 'alpinejs';
import "../components/ai-vet-chat"
import "../components/animal-treatment-selector"
import "../components/dosage-calculator"
import "../components/treatment-guide"
import AppAnalytics from '../analytics/AppAnalytics';

AppAnalytics.getPlausible();

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

document.addEventListener('alpine:init', () => {

  Alpine.data('common', function() {
    return {
    }
  })

});

Alpine.start();

